"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useEffect, useState } from "react";
import { ArrowRight, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourTrustedVAAndNCTaxPartners() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return <section data-section-id="232360" id="estúdio-de-podcast-em-pinheiros-e-produtora-de-vídeo-em-são-paulo" className="bg-background text-foreground relative overflow-hidden min-h-screen flex items-center hero mt-0 ![padding:0px_0px_160px_0px]">
      {}
      <div className="absolute inset-0 pointer-events-none hero-decorative" style={{
      background: `linear-gradient(135deg, var(--muted) 0%, var(--background) 60%, var(--accent) 100%)`,
      opacity: 0.4
    }} />

      <div className="relative w-full max-w-7xl mx-auto section ![padding:40px_48px_160px_48px]">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-0">

          {}
          <div ref={leftRef} className="w-full lg:w-3/5 lg:pr-16 flex flex-col justify-center" style={{
          opacity: mounted && leftVisible ? 1 : 0,
          transform: mounted && leftVisible ? "translateY(0px)" : "translateY(40px)",
          transition: "opacity 0.8s ease, transform 0.8s ease"
        }}>
            {}
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px w-10" style={{
              background: `var(--primary)`
            }} />
              <span className="text-xs font-mono uppercase tracking-widest font-medium" style={{
              color: `var(--primary)`
            }}>
                Audiovisual de Alta Performance
              </span>
            </div>

            {}
            <h1 className="font-default text-4xl md:text-5xl xl:text-6xl font-bold leading-tight mb-6" style={{
            color: `var(--foreground)`,
            letterSpacing: `var(--tracking-tight)`,
            fontFamily: `var(--font-serif)`
          }}>Estratégia e conteúdo para&nbsp;&nbsp;<span className="relative inline-block" data-ast-id="f:/src/pages/Home/sections/YourTrustedVAAndNCTaxPartners.tsx|sig:yh4ngo" data-ast-start="2429" data-ast-end="2723" contenteditable="false" style={{
              color: 'var(--primary)'
            }}>gerar clientes em São Paulo</span></h1>

            {}
            <p className="text-base md:text-lg leading-relaxed mb-4 max-w-xl" style={{
            color: `var(--muted-foreground)`
          }}><span data-ast-id="f:/src/pages/Home/sections/YourTrustedVAAndNCTaxPartners.tsx|sig:hz1rmm" data-ast-start="2890" data-ast-end="3052">Estúdio de podcast em</span><strong data-ast-id="f:/src/pages/Home/sections/YourTrustedVAAndNCTaxPartners.tsx|sig:wax3ty" data-ast-start="3052" data-ast-end="3272" style={{
              color: 'var(--foreground)'
            }}> Pinheiros</strong>&nbsp;e produtora de vídeo com estrutura completa para posicionamento e conversão digital.</p>

            {}
            <ul className="flex flex-col gap-2 mb-8">
              <li className="flex items-center gap-2 text-sm" style={{
              color: `var(--muted-foreground)`
            }}>
                <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{
                background: 'var(--primary)'
              }}></span>
                Estúdio de podcast completo em Pinheiros, pronto para gravar
              </li>
              <li className="flex items-center gap-2 text-sm" style={{
              color: `var(--muted-foreground)`
            }}>
                <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{
                background: 'var(--primary)'
              }}></span>
                Conteúdo editado e preparado para publicação
              </li>
              <li className="flex items-center gap-2 text-sm" style={{
              color: `var(--muted-foreground)`
            }}>
                <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{
                background: 'var(--primary)'
              }}></span>
                Equipe acompanhando você em todo o processo
              </li>
            </ul>

            {}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button size="lg" className="font-default font-medium text-sm px-8 py-3 rounded-full shadow-lg hover:scale-105 transition-transform" style={{
              background: `var(--primary)`,
              color: `var(--primary-foreground)`,
              border: "none"
            }} asChild>
                <Link to="https://wa.me/5511969100007?text=Olá,%20vim%20pelo%20site%20da%20ITC+%20e%20quero%20entender%20como%20vocês%20podem%20me%20ajudar">
                  <SafeHydrate><Calendar className="size-4" /></SafeHydrate>
                  Falar com especialista
                </Link>
              </Button>

              <Button size="lg" variant="outline" className="font-default font-medium text-sm px-8 py-3 rounded-full" style={{
              borderColor: `var(--border)`,
              color: `var(--foreground)`
            }} asChild>
                <Link to="https://itcmais.com/o-estudio">
                  Conheça o Estúdio
                  <ArrowRight className="size-4" />
                </Link>
              </Button>
            </div>

            {}
            <div className="mt-8 flex items-center gap-4 pt-6" style={{
            borderTop: `1px solid var(--border)`
          }}>
              <div className="flex flex-col">
                <span className="text-2xl font-bold font-default" style={{
                color: `var(--foreground)`,
                fontFamily: `var(--font-serif)`
              }}>
                  500+
                </span>
                <span className="text-xs" style={{
                color: `var(--muted-foreground)`
              }}>
                  Projetos Entregues
                </span>
              </div>
              <div className="w-px h-10 self-center" style={{
              background: `var(--border)`
            }} />
              <div className="flex flex-col">
                <span className="text-2xl font-bold font-default" style={{
                color: `var(--foreground)`,
                fontFamily: `var(--font-serif)`
              }}>
                  Pinheiros
                </span>
                <span className="text-xs" style={{
                color: `var(--muted-foreground)`
              }}>
                  Localização Premium
                </span>
              </div>
              <div className="w-px h-10 self-center" style={{
              background: `var(--border)`
            }} />
              <div className="flex flex-col">
                <span className="text-2xl font-bold font-default" style={{
                color: `var(--foreground)`,
                fontFamily: `var(--font-serif)`
              }}>
                  4K
                </span>
                <span className="text-xs" style={{
                color: `var(--muted-foreground)`
              }}>
                  Qualidade Cinema
                </span>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className="w-full lg:w-2/5 relative" style={{
          opacity: mounted && rightVisible ? 1 : 0,
          transform: mounted && rightVisible ? "translateY(0px)" : "translateY(50px)",
          transition: "opacity 0.9s ease 0.2s, transform 0.9s ease 0.2s"
        }}>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/5]">
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/pinheiros_studio_set.png" alt="Estúdio de podcast profissional em Pinheiros com câmeras e microfones de alta tecnologia" className="w-full h-full object-cover" />

              {}
              <div className="absolute inset-0" style={{
              background: `linear-gradient(180deg, transparent 30%, var(--primary) 100%)`,
              opacity: 0.4
            }} src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/pinheiros_studio_set.png" />

              {}
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none" style={{
              opacity: 0.2
            }}>
                <div className="w-3/4 h-3/4" style={{
                border: `2px solid var(--primary)`,
                borderRadius: "var(--radius)",
                transform: "rotate(-3deg)"
              }} />
                <div className="absolute w-2/3 h-2/3" style={{
                border: `1px solid var(--primary)`,
                borderRadius: "var(--radius)",
                transform: "rotate(2deg)"
              }} />
              </div>

              {}
              <div className="absolute bottom-0 left-0 right-0 p-6" style={{
              background: `linear-gradient(0deg, var(--primary) 60%, transparent 100%)`
            }}>
                
                <h3 className="font-default text-xl font-semibold !text-center" style={{
                color: `var(--primary-foreground)`,
                fontFamily: `var(--font-serif)`
              }}>
                  Produção Audiovisual
                </h3>
                <p className="text-sm mt-1 !text-center" style={{
                color: `color-mix(in srgb, var(--primary-foreground), transparent 20%)`
              }}>
                  Pinheiros / Faria Lima — São Paulo, SP
                </p>
              </div>

              {}
              <div className="absolute top-4 right-4 w-12 h-12 rounded-full flex items-center justify-center" style={{
              background: `var(--primary)`,
              opacity: 0.95
            }}>
                
              </div>
            </div>

            {}
            <div className="absolute -bottom-4 -right-4 w-full h-full rounded-2xl -z-10" style={{
            background: `var(--primary)`,
            opacity: 0.1
          }} />
            <div className="absolute -top-4 -left-4 w-16 h-16 rounded-full -z-10" style={{
            background: `var(--primary)`,
            opacity: 0.15
          }} />
          </div>
        </div>
      </div>
    </section>;
}